// removed by extract-text-webpack-plugin
module.exports = {"baseColor":"baseColor___-BXAS","backgroundWrapper":"backgroundWrapper___4-y6_","logo":"logo___jAkU0","headerWrapper":"headerWrapper___3U8-N","logoPanel":"logoPanel___3zPFp","titleWrapper":"titleWrapper___2FSdC","loginWrapper":"loginWrapper___3MqM7","loginBox":"loginBox___2vc6N"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/login/Index.less
 ** module id = 569
 ** module chunks = 1
 **/